import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { SuggestionOption } from '../types.ts';

export type SuggestionCardProps = {
  suggestion: SuggestionOption;
  onClick: () => void;
};

export function SuggestionCard({ suggestion, onClick }: SuggestionCardProps) {
  const { label, description, Icon } = suggestion;
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      aria-label={label}
      sx={theme => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        textAlign: 'left',
        gap: 0.5,
        px: 1.5,
        py: 0.5,
        border: 0,
        borderRadius: 2,
        backgroundColor: theme.palette.background.paper,
        cursor: 'pointer',
        width: 280,
        minHeight: 100,
        flexShrink: 0,
        alignSelf: 'stretch',
        overflow: 'hidden',
        '&:focus-visible': {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: 2,
        },
      })}
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography
            variant="body2"
            component="span"
            sx={{
              fontWeight: 'fontWeightBold',
              fontSize: '1rem',
            }}
          >
            {label}
          </Typography>
          {description && (
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                lineHeight: 1.4,
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
              }}
            >
              {description}
            </Typography>
          )}
        </Box>
        <Box
          sx={theme => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.main,
            flexShrink: 0,
            alignSelf: 'center',
            // Icon comes from the caller (MUI or Phosphor); size it here so both render at 20px.
            '& svg': { fontSize: 20 },
          })}
        >
          <Icon />
        </Box>
      </Box>
    </Box>
  );
}
